const roles = [
  { label: 'Référant RGPD', value: -1 },
  { label: 'Informaticien', value: 1 },
  { label: 'Réprésentant légal', value: 2 },
  { label: 'Transactionnaire', value: 3 },
  { label: 'Directeur commercial', value: 4 },
  { label: 'Directeur agence', value: 5 },
  { label: 'Comptable', value: 6 },
  { label: 'Gestionnaire', value: 7 },
  { label: 'Assistant', value: 8 },
  { label: 'Juriste', value: 9 },
  { label: 'Autre', value: 10 },
  { label: 'Directeur administratif financier', value: 11 },
  { label: 'Responsable service', value: 12 },
  { label: 'Secrétaire', value: 13 },
];

export const getValueByLabel = (label: string) => {
  const foundRole = roles.find((r) => r.label === label);
  return foundRole ? foundRole.value : null;
};
